import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SecurityGroupForm from '../SecurityGroupForm';
import { addApp, removeApp, toggleSecurityModal, updateSecurityGroup } from '../../../actions/SecurityGroupActions';
import { Modes, Statuses } from '../../../constants/Enums';
import { createSecurityGroup } from '../../../api/SecurityGroupApi';
import SecurityGroup from '../../../models/SecurityGroup';
import Routes from '../../../constants/Routes';

class CreateSecurityGroupForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            securityGroup: {},
            showConfirmModal: false,
            error: {},
            showError: false,
            formErrors: [],
            operationStatus: Statuses.NOT_STARTED
        };
    }

    setConfirmModalOpen = (isOpen) => {
        this.setState({ showConfirmModal: isOpen });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setConfirmModalOpen(true);
    };

    setApps = (appId) => {
        let securityGroup = this.state.securityGroup;
        if (securityGroup.appIds && securityGroup.appIds.includes(appId)) {
            this.props.removeApp(appId);
        } else {
            this.props.addApp(appId);
        }
    };

    submitForm = () => {
        let { description, name } = this.props.form.values;
        let { securityGroup } = this.props;
        securityGroup = { ...securityGroup, description, name };
        this.props.createSecurityGroup(securityGroup);
        this.setState({ showConfirmModal: false });
    };

    UNSAFE_componentWillMount() {
        let securityGroup = new SecurityGroup('', '', {}, [], []);
        this.props.updateSecurityGroup(securityGroup);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.securityGroup && nextProps.securityGroup !== this.state.securityGroup) {
            this.setState({ securityGroup: nextProps.securityGroup });
        }
        if (nextProps.activeApps !== this.props.activeApps) {
            this.setState({ activeApps: { ...nextProps.activeApps } });
        }
        if (nextProps.form && nextProps.form.syncErrors !== this.state.formErrors) {
            this.setState({ formErrors: nextProps.form.syncErrors });
        }
        if (nextProps.operationStatus !== this.state.operationStatus) {
            this.setState({ operationStatus: nextProps.operationStatus });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.operationStatus !== this.state.operationStatus) {
            if (this.state.operationStatus === Statuses.SUCCESS)
                this.props.redirect(Routes.SECURITY_GROUPS);
        }
    }

    render() {
        return (
            <SecurityGroupForm toggleSecurityModal={this.props.toggleSecurityModal} isFetching={this.props.isFetching}
                               showError={this.props.showError}
                               mode={Modes.CREATE} apps={this.props.apps} setConfirmModalOpen={this.setConfirmModalOpen}
                               submitForm={this.submitForm}
                               showConfirmModal={this.state.showConfirmModal} handleSubmit={this.handleSubmit}
                               errorMessage={this.props.errorMessage}
                               buttonIsDisabled={() => {
                                   return this.state.formErrors != null;
                               }} cancel={() => this.props.redirect(Routes.SECURITY_GROUPS)}
                               permissions={this.props.permissions}
                               isModalOpen={this.props.isModalOpen}
                               disabled={false} removeApp={this.setApps} addApp={this.setApps} />
        );
    }
}

CreateSecurityGroupForm.propTypes = {
    redirect: PropTypes.func.isRequired,
    toggleSecurityModal: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool,
    showError: PropTypes.bool,
    errorMessage: PropTypes.string,
    form: PropTypes.object,
    permissions: PropTypes.array,
    securityGroup: PropTypes.object,
    users: PropTypes.array,
    apps: PropTypes.array,
    error: PropTypes.object,
    isFetching: PropTypes.bool,
    activeApps: PropTypes.array,
    operationStatus: PropTypes.number,
    removeApp: PropTypes.func,
    addApp: PropTypes.func,
    createSecurityGroup: PropTypes.func,
    updateSecurityGroup: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        form: state.form.createSecurityGroup,
        permissions: state.securityGroup.permissions,
        securityGroup: state.securityGroup.securityGroup,
        isModalOpen: state.securityGroup.isModalOpen,
        users: state.authenticationReducer.users,
        apps: state.securityGroup.apps,
        error: state.securityGroup.err,
        isFetching: state.securityGroup.isFetching,
        activeApps: state.securityGroup.activeApps,
        operationStatus: state.securityGroup.operationStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSecurityModal,
        updateSecurityGroup,
        createSecurityGroup,
        addApp,
        removeApp
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateSecurityGroupForm);